import React, { useState, useEffect } from "react";
import {
  Grid,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  TableContainer,
  CardContent,
  Card,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import { images } from "../../config/images";
import { useSelector } from "react-redux";
import { getReport } from "../Reports & Approvals/services";
import { param } from "jquery";
import { useLocation, useParams } from "react-router-dom";
import { getBatchId } from "./services";

const ProductionLineVisualInspection = ({ closeModal, props }) => {
  const [batchType, setBatchType] = useState();
  const [reportStatus, setReportStatus] = useState([]);
  const [reportPayload, setReportPayload] = useState([]);
  const [Report_Payload_Data, setReport_Payload_Data] = useState();
  const [selected, setSelected] = React.useState([]);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isLoading, setLoading] = useState(false);
  const [sendingID, setSendingId] = useState(false);
  const [approveStatus, setApproveStatus] = useState("");
  const [rejectedButton, setRejectedButton] = useState(false);
  const [sendingmsg, setSendingMsg] = useState(false);
  const [status1, setStatus1] = useState(null);
  const [comment, setComment] = useState("");
  const [checkUidData, setCheckUidData] = useState(false);

  const initiallValue = {
    Date: "",
    B_No: "",
    UID: "",
    Test_date: "",
    Test_Time: "",
    Shift: "",
    Lot_No: "",
    Class: "",
    Size: "",
    Thickness: "",
    Print_Result: "",
    RorL: "",
    Approve_status: "",
  };
  const { userPermission } = useSelector((state) => state.userState);
  const location = useLocation();
  const params = useParams();
  const batchId = location?.state?.batch_types || params.id;
  const [searchText, setSearchText] = useState(initiallValue);

  useEffect(() => {
    getBatchData();
  }, []);

  const getBatchData = async () => {
    try {
      const resp = await getBatchId(batchId);

      if (resp.status == 200 || resp.status == 201) {
        setBatchType(resp.data);
      }
    } catch (error) {
      setLoading(false);
      console.log("handleSubmit", error);
    }
  };

  useEffect(() => {
    handleApprovedStatus();
  }, []);

  const handleApprovedStatus = async (row, status) => {
    console.log("statusstatusstatus", status);
    setLoading(true);
    const params = {
      batch_id: batchId,
    };
    setBatchType(row);
    try {
      const resp = await getReport(params);
      setLoading(false);
      if (resp.status == 200 || resp.status == 201) {
        setReportStatus(resp.data.payload.payload);
        setReportPayload({
          Accepted_Qty: resp.data.payload.accepted,
          Rejected_Qty: resp.data.payload.rejected,
        });
        setReport_Payload_Data(resp.data.payload.payload);
        setApproveStatus(status);
      }
    } catch (error) {
      setLoading(false);
      console.log("handleSubmit", error);
    }

    // setGlovesTable(false);
  };

  const tableHeadStyle = {
    position: "sticky",
    top: "-7px",
    zIndex: isLoading ? "auto" : 9,
  };

  const handleToastMsg = () => {
    toast.error("You don't have access", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const handleSubmit = async () => {};

  const approvedModal = () => {
    // setSendingId(true);
    // setStatus1(1);
  };

  const handleCancle = () => {
    // setSendingId(false);
  };
  const handleClose = () => {
    // setSendingMsg(false);
  };

  const rejectedModal = () => {
    // setSendingMsg(true);
    // setStatus1(0);
    // setRejectedButton(!rejectedButton);
  };

  const handleCheckUidData = (finddata) => {
    setCheckUidData(finddata);
  };

  return (
    <>
      <div className="min-h-screen bg-[#f5f3ff] p-8 dashboard-wrapper page-wraper">
        <div className="page-header">
          <div
            onClick={() => closeModal(false)}
            className="page-back-btn"
            style={{ cursor: "pointer" }}
          >
            <ArrowBackIcon />
            <span>Visual Inspection</span>
          </div>
        </div>

        <div className="mt-5">
          <div className="header-approval-data electricTest-data">
            <Grid container>
              <Grid
                lg={3}
                md={6}
                sm={6}
                xs={12}
                sx={{ P: 0 }}
                className="single-data-item"
              >
                <Table className="no-border-table transparent-table common-table">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Mfg Date:
                      </TableCell>
                      <TableCell>
                        {dayjs(batchType ? batchType.created_at : "").format(
                          "YYYY-MM-DD"
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Batch No:
                      </TableCell>
                      <TableCell>
                        {batchType ? batchType.batch_type : ""}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
              <Grid
                lg={2}
                md={6}
                sm={6}
                xs={12}
                sx={{ P: 0 }}
                className="single-data-item"
              >
                <Table className="no-border-table transparent-table common-table">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Lot No:</TableCell>
                      <TableCell>
                        {batchType ? batchType.lot_number : ""}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Thickness:
                      </TableCell>
                      <TableCell>
                        {Report_Payload_Data
                          ? Report_Payload_Data[0].thickness
                          : "-"}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
              <Grid
                lg={2}
                md={6}
                sm={6}
                xs={12}
                sx={{ P: 0 }}
                className="single-data-item"
              >
                <Table className="no-border-table transparent-table common-table">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Class:</TableCell>
                      <TableCell>
                        {batchType ? batchType.class_name : ""}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Size:</TableCell>
                      <TableCell>
                        {batchType ? batchType.size_name : ""}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
              <Grid
                lg={2}
                md={6}
                sm={6}
                xs={12}
                sx={{ P: 0 }}
                className="single-data-item"
              >
                <Table className="no-border-table transparent-table common-table">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Accepted Qty:
                      </TableCell>
                      <TableCell>{reportPayload.Accepted_Qty}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Rejected Qty:
                      </TableCell>
                      <TableCell>{reportPayload.Rejected_Qty}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
              <Grid
                lg={3}
                md={6}
                sm={6}
                xs={12}
                sx={{ P: 0 }}
                className="single-data-item"
              >
                <Table className="no-border-table transparent-table common-table">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Inspector Name:
                      </TableCell>
                      <TableCell>
                        {batchType
                          ? batchType.inspector_name
                            ? batchType.inspector_name
                            : "-"
                          : ""}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Revision
                      </TableCell>
                      <TableCell>-</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
            </Grid>
          </div>

          <div className="table-responsive">
            <TableContainer
              style={{
                border: "1px solid #a9b0bd",
                maxHeight: "60vh",
                background: "#ffff",
              }}
              className="reportTable"
            >
              <Table
                aria-label="reports"
                className="statusflow"
                style={{ width: "fit-content" }}
              >
                <TableHead style={tableHeadStyle}>
                  <TableRow>
                    <TableCell className="statusflow-defects">
                      <div className="p-3">Defects</div>
                    </TableCell>
                    {reportStatus && reportStatus && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          return (
                            <TableCell
                              className={
                                status1.visual_inspection != null
                                  ? !status1.visual_inspection
                                    ? "defects-head"
                                    : ""
                                  : ""
                              }
                            >
                              <div className="defects">
                                UID:{status1.uid_type}
                                <br />
                                Date:
                                {dayjs(status1.created_at).format("YYYY-MM-DD")}
                                <br />
                                Shift:{" "}
                                {status1.visual_inspection_details
                                  ? status1.visual_inspection_details.shift
                                  : ""}
                              </div>
                            </TableCell>
                          );
                        })
                      : ""}
                  </TableRow>
                </TableHead>

                <TableBody>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">01</b> Bubbles between fingers{" "}
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }

                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .bubbles_between_fingers
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .bubbles_between_fingers
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">02</b> Bubbles at fingertips
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .bubbles_at_fingertips
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .bubbles_at_fingertips
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">03</b> Other position bubbles
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .other_position_bubbles
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .other_position_bubbles
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">04</b> Thin patch fingers
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .thin_patch_fingers
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .thin_patch_fingers
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">05</b> Thin patch crutch
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .thin_patch_crutch
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .thin_patch_crutch
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">06</b> Thin patch between finger
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .thin_patch_between_finger
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .thin_patch_between_finger
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">07</b> Inside crack defect
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .inside_crack_defect
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .inside_crack_defect
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">08</b> Crease
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details.crease
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details.crease
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">09</b> Pinholes fingertips
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .pinholes_fingertips
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .pinholes_fingertips
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">10</b> Pinholes other positions
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .pinholes_other_positions
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .pinholes_other_positions
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">11</b> Wet coagulant fingertips
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .wet_coagulant_fingertips
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .wet_coagulant_fingertips
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">12</b> Particles
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .particles
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .particles
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">13</b> Crack defects between
                      fingers
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .crack_defects_between_fingers
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .crack_defects_between_fingers
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">14</b> Ripples on fingers
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .ripples_on_fingers
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .ripples_on_fingers
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">15</b> Ripples on other positions
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .ripples_on_other_positions
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .ripples_on_other_positions
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">16</b> Inner/Between(coat) split
                      line
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .inner_between_coat_split_line
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .inner_between_coat_split_line
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">17</b> Drops of coagulant
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .drops_of_coagulant
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .drops_of_coagulant
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">18</b> Bad gelation
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .bad_gelation
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .bad_gelation
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">19</b> Bad gelation of finger
                      side
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .bad_gelation_of_finger_side
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .bad_gelation_of_finger_side
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">20</b> Delamination
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .delamination
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .delamination
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">21</b> Lack of coagulant
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .lack_of_coagulant
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .lack_of_coagulant
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">22</b> Bad rolled edge
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .bad_rolled_edge
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .bad_rolled_edge
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">23</b> Crack defects ON fingers
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .crack_defects_on_fingers
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .crack_defects_on_fingers
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">24</b> Inner side impression mark
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .inner_side_impression_mark
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .inner_side_impression_mark
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">25</b> Pit mark
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .pit_mark
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details.pit_mark
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">26</b> Cissing
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .cissing
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details.cissing
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">27</b> Latex runs at fingertips
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .latex_runs_at_fingertips
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .latex_runs_at_fingertips
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">28</b> Coagulant foam
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .coagulant_foam
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .coagulant_foam
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">29</b> Peel of fingertips
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .peel_of_fingertips
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .peel_of_fingertips
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">30</b> Blister
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .blister
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details.blister
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">31</b> Line
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details.line
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details.line
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">32</b> Split Line
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }

                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .split_line
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .split_line
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">33</b> Inside bubbles at finger
                      tips
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .inside_bubbles_at_finger_tips
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .inside_bubbles_at_finger_tips
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">34</b> Inside bubbles at other
                      position
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .inside_bubbles_at_other_posi
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .inside_bubbles_at_other_posi
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">35</b> Inside bubbles between
                      finger
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .inside_bubbles_between_finger
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .inside_bubbles_between_finger
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">36</b> Webline bubbles
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div
                                  className={`status-icon ${
                                    status1.visual_inspection_details
                                      ? status1.visual_inspection_details
                                          .webline_bubbles
                                        ? "pass"
                                        : "falied"
                                      : "status-icon-disabled"
                                  }`}
                                >
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .webline_bubbles
                                      ? "P"
                                      : "F"
                                    : "status-icon-disabled"}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">37</b>Other defects(Hold/No
                      Hold/Minor Fault)
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div>
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details.defects
                                    : ""}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                  <TableRow className="historyTitle mt-2 text-center">
                    <TableCell className="statusflow-defects">
                      <b className="font-bold">38</b> Defects
                    </TableCell>
                    {reportStatus.length && Array.isArray(reportStatus)
                      ? reportStatus.map((status1) => {
                          if (
                            status1.visual_inspection_details
                              ? status1.visual_inspection_details
                                  .bubbles_between_fingers
                                ? true
                                : true
                              : false
                          ) {
                            if (!checkUidData) {
                              handleCheckUidData(
                                status1.visual_inspection_details
                                  ? status1.visual_inspection_details
                                      .bubbles_between_fingers
                                    ? true
                                    : true
                                  : false
                              );
                            }
                          }
                          return (
                            <>
                              <TableCell>
                                <div className="text-center">
                                  {status1.visual_inspection_details
                                    ? status1.visual_inspection_details
                                        .othere_defect
                                    : ""}
                                </div>
                              </TableCell>
                            </>
                          );
                        })
                      : ""}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            {isLoading && <Loader />}
          </div>

          <div className="d-flex justify-content-end aborted">
            <p style={{ margin: 0, marginBottom: 0 }}>
              Powered by <b>Hikar&#174;Technomation</b> Private Limited &#169;
              All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductionLineVisualInspection;
